import { Moment } from 'moment'

import { DATE_FORMAT } from 'main/util/date'

export function queryVariables(schoolId: number, anchorMoment: Moment) {
  return {
    beginsOn: anchorMoment.format(DATE_FORMAT),
    endsOn: anchorMoment.add(28, 'days').format(DATE_FORMAT),
    schoolId: schoolId.toString(),
    schoolIdInt: schoolId,
  }
}
